export default {
	four:{//4-4-4-4-4
		update:function(el,binding){
			if(binding.value.length!=1){
				return;
			}
			var val = el.value || el.innerText;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value,'g');
			val = val.replace(reg,"")
			var arr = val.split("");
			
			var format = ""
			for(let i=0;i<arr.length;i++){
				if(i%4==0 && i!=0){
					format += binding.value;
				}
				format += arr[i];
			}
			el.value = format;
            // el.innerText = format;
		}
	},
    txt: {
        inserted: function(el,binding){
            if(binding.value.length!=1){
                return;
            }
            var val = el.innerText;
            console.log(val)
            //每次输入的时候先把分隔符去掉
            var reg = new RegExp(binding.value,'g');
            val = val.replace(reg,"")
            var arr = val.split("");

            var format = ""
            for(let i=0;i<arr.length;i++){
                if(i%4==0 && i!=0){
                    format += binding.value;
                }
                format += arr[i];
            }
            el.innerText = format;
        }
    },
	tel:{//手机号3-4-4
		update:function(el,binding){
			if(binding.value.length!=1){
				return;
			}
			var val = el.value;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value,'g');
			val = val.replace(reg,"")
			var arr = val.split("");
			
			for(let i=0;i<arr.length;i++){
				if(i==3){
					arr.splice(3,0,binding.value);
				}else if(i==(3 + 1) + 4){
					arr.splice((3 + 1) + 4,0,binding.value);
				}
			}
			el.value = arr.join("");
		}
	},
  iosbug: {
    inserted: function (el, binding) {
      el.onblur = function () {
        setTimeout(() => {
          document.dispatchEvent(new Event('touchmove'));
          var doc = document.body || document.documentElement;
          var scrollTop = doc.scrollTop;
          doc.scrollTop = scrollTop + 10;
          setTimeout(() => {
            doc.scrollTop = scrollTop;
            console.log(121)
          }, 30);
        }, 100);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/num-format.js